<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Untagged Transactions</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
				
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-overlay :show="this.working" rounded="sm">
			<div class="row">
				<div class="col-md-6">
					<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
					<b-table :filter="search" striped hover small :items="untaggedTransactions.uncategorisedByName" :fields="['merchant', 'count']" selectable select-mode="single" @row-clicked="onTransactionsSelected"></b-table>					
				</div>
				<div class="col-md-6" v-if="selected">
					<h4><strong>Merchant: {{selected.merchant}}</strong> - {{selected.count}} untagged</h4>
					<div v-for="p in transactionClassifications" :key="p.id">
						<b-button v-b-modal.modal-confirm @click="catClicked(p, false)" :class="'parent-cat ' + ((suggested && p.mgClassification.id == suggested.id) ? 'suggested' : '')">{{p.mgClassification.mgClassification}}</b-button>
						<b-button v-b-modal.modal-confirm @click="catClicked(c, true)" :class="'child-cat ' + ((suggested && c.mgClassification.id == suggested.id) ? 'suggested' : '')" size="sm" v-for="c in p.children" :key="c.mgClassification.id">{{c.mgClassification.mgSubClassification}}</b-button>
					</div>
				</div>
			</div>
			<b-modal hide-footer centered v-if="selected && selectedClassification" id="modal-confirm" :title="'Tag ' + selected.count + ' Transactions?'">
				<p>Tag {{selected.count}} <strong>{{selected.merchant}}</strong> transactions as <strong>{{selectedSub ? selectedClassification.mgClassification.mgSubClassification : selectedClassification.mgClassification.mgClassification}}</strong>?</p>
				<br/>
				<div class="row">
					<div class="col-md-6">
					</div>
					<div class="col-md-3">
						<b-button @click="cancel">Forget It</b-button>
					</div>
					<div class="col-md-3">
						<b-button variant="success" @click="tagTransactions">Yes Please</b-button>
					</div>
				</div>
			</b-modal>
		</b-overlay>
	</div>
</div>
</template>
<script>
export default {
  name: 'UntaggedTransactions',
  data() {
	return{
		untaggedTransactions: null,
		transactionClassifications: null,
		search:"",
		working: true,
		selected: null,
		selectedSub: false,
		selectedClassification : null,
		suggested: null
	}
  },
  methods: {
	tagTransactions: function() {
		this.working = true;
		var request = {transactionIDs: this.selected.iDs, newClassificationID: this.selectedClassification.mgClassification.id};
		this.$http.post(this.$config.ApiUri + "/Customers/Transactions/BulkUntagged/BulkTagRequests", request)
			.then(() => {
				this.onLoad();
				this.selected = null;
				this.working = false;
			}
		);
		this.$bvModal.hide('modal-confirm');
	},
	cancel: function() {
		this.$bvModal.hide('modal-confirm');
	},
	catClicked: function(sel, sub){
		this.selectedClassification = sel;
		this.selectedSub = sub;
	},
	getUntaggedTransactions: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/Transactions/BulkUntagged")
			.then((result) => {
				this.untaggedTransactions = result.data;
				this.working = false;
			}
		)
	},
	getTransactionClassifications: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/TransactionClassifications")
			.then((result) => {
				this.transactionClassifications = result.data;
				this.working = false;
			}
		)
	},
	getSuggestedClassification: function(merchant){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers/Transactions/Vendors/" + merchant + "/ClassificationSuggestions")
			.then((result) => {
				this.suggested = result.data;
				this.working = false;
			}
		)
	},
	onLoad() {
		this.working = true;
		this.getUntaggedTransactions();
		this.getTransactionClassifications();
	},
	onTransactionsSelected(record)
	{
		this.working = true;
		this.selected = record;
		this.getSuggestedClassification(this.selected.merchant);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style scoped="true">
	.child-cat {
		margin:3px;
		background-color: rgb(104, 84, 150);
	}
	.parent-cat {
		margin:3px;
		background-color: rgb(53, 43, 77);
	}
	.suggested
	{
		background-color: rgb(134, 109, 194);
		animation-name: stretch;
		animation-duration: 1.0s;
		animation-timing-function: ease-out;
		animation-direction: alternate;
		animation-iteration-count: infinite;
		animation-play-state: running;
	}
	@keyframes stretch {
		0% {
			transform: scale(1);
			
		}

		50% {
			
		}

		100% {
			transform: scale(1.1);
			background-color: rgb(73, 192, 113);
		}
	}
</style>